import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "command-button" };
const _hoisted_2 = ["title", "disabled", "tabindex"];
import { ref, watch } from 'vue';
import { isAnyGranted, isGranted } from "../services/AccessManager";
import { tt } from "../services/Translator";
import Icon from "./Icon.vue";
import Spinner from "./Spinner.vue";
import ConfirmationDialog from "./ConfirmationDialog.vue";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CommandButton',
    props: {
        command: {},
        label: {},
        title: {},
        icon: {},
        iconStyle: {},
        classes: {},
        disabled: { type: Boolean },
        previewUrl: {},
        tabIndex: {}
    },
    emits: [
        'execute',
        'success',
        'error'
    ],
    setup(__props, { emit: __emit }) {
        const { t, te } = useI18n();
        const emit = __emit;
        const props = __props;
        const effectiveIcon = props.icon ?? props.command.icon();
        const disabled_ = ref(false);
        const executing = ref(false);
        const confirmed = ref(false);
        const showConfirmationModal = ref(false);
        init();
        watch(() => props.disabled, init);
        function init() {
            disabled_.value = props.disabled ?? false;
            const permissions = props.command.requiresPermission();
            if (permissions !== null &&
                (Array.isArray(permissions) && !isAnyGranted(permissions)
                    || (!Array.isArray(permissions) && !isGranted(permissions)))) {
                disabled_.value = true;
            }
        }
        function execute() {
            if (!confirmed.value && props.command.needsConfirmation()) {
                showConfirmationModal.value = true;
                return;
            }
            executing.value = true;
            emit('execute');
            props.command.enqueue()
                .then(result => {
                emit('success', result);
            })
                .catch(error => {
                emit('error', error);
            })
                .finally(() => {
                executing.value = false;
                confirmed.value = false;
            });
        }
        function confirm() {
            confirmed.value = true;
            showConfirmationModal.value = false;
            execute();
        }
        function commandLabel() {
            if (props.label === '') {
                return undefined;
            }
            if (props.label) {
                return props.label;
            }
            return tt(`command.${props.command.name()}`, props.command.name());
        }
        function commandTitle() {
            return props.title === '' ? undefined : (props.title || tt(`command.${props.command.name()}`, props.command.name()));
        }
        function confirmTitle() {
            return tt(`command.${props.command.name()}.confirm_title`, 'command.confirm_title');
        }
        function confirmText() {
            return tt(`command.${props.command.name()}.confirm_text`, 'command.confirm_text');
        }
        function confirmBtnLabel() {
            return tt(`command.${props.command.name()}.confirm`, `command.${props.command.name()}`, 'command.confirm');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    class: _normalizeClass(__props.classes ?? 'button'),
                    title: commandTitle(),
                    disabled: disabled_.value || executing.value,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (execute()), ["prevent"])),
                    tabindex: __props.tabIndex ?? 0
                }, [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                        (_unref(effectiveIcon))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (executing.value)
                                    ? (_openBlock(), _createBlock(Spinner, {
                                        key: 0,
                                        loading: true
                                    }))
                                    : (_openBlock(), _createBlock(Icon, {
                                        key: 1,
                                        name: _unref(effectiveIcon),
                                        "icon-style": __props.iconStyle ?? 'regular'
                                    }, null, 8, ["name", "icon-style"]))
                            ], 64))
                            : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(commandLabel()), 1)
                    ])
                ], 10, _hoisted_2),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (showConfirmationModal.value)
                    ? (_openBlock(), _createBlock(ConfirmationDialog, {
                        key: 0,
                        onCancel: _cache[1] || (_cache[1] = ($event) => (showConfirmationModal.value = false)),
                        onConfirm: confirm,
                        dangerous: __props.command.isDangerous(),
                        title: confirmTitle(),
                        text: confirmText(),
                        "confirm-icon": __props.command.icon(),
                        "confirm-label": confirmBtnLabel(),
                        "preview-url": __props.previewUrl
                    }, null, 8, ["dangerous", "title", "text", "confirm-icon", "confirm-label", "preview-url"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
